import React, { Component } from 'react';
import styled from 'styled-components';
import Shubox from 'shubox'
import { Row, Field, Label, Select, TextArea, Button }  from '../../generic';

const Image = styled.img`
  max-width: 250px;
  max-height: 250px;
  margin: 0 0 10px;
  border: 1px solid #ccc;
  padding: 5px;
`

const ButtonUpload = Button.withComponent('div').extend`
  padding: 0;
  > div {
    padding: 8px 30px;
  }
`;

const Progress = styled.div`
  height: 15px;
  position: relative;
  background: #eee;
  max-width: 250px;
  margin: 10px 0;
  border: 1px solid #777;
`

const Bar = styled.div`
  position: absolute;
  background: rgb(82, 107, 247);
  top: 0; left: 0;
  height: 100%;
  width: 0;
`

class Uploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      done: true,
      showExamples: true,
    }
    this.uploadButton = React.createRef()
    this.shuboxify = this.shuboxify.bind(this)
    this.removeImage = this.removeImage.bind(this)
  }

  // shuboxDoubleEncodeURI(str) {
  //   return encodeURIComponent(encodeURIComponent(str).replace(/[~!*()']/g, function(c) {
  //     return '%' + c.charCodeAt(0).toString(16);
  //   }));
  // }

  shuboxFilePath(file) {
    // return file.s3url.split('/').slice(0, 5).join('/') + '/' + this.shuboxDoubleEncodeURI(file.s3.split('/')[2]).replace(/2520/g, '2B')
    // return file.s3url.split('/').slice(0, 5).join('/') + '/' + encodeURIComponent(file.s3.split('/')[2]) // DEV
    return file.s3url.split('/').slice(0, 6).join('/') + '/' + encodeURIComponent(file.s3.split('/')[2]); // PROD
  }

  shuboxify() {
    let elem = this.uploadButton.current;
    if (elem) {
      if (elem.dropzone) {
        elem.dropzone.destroy();
      }

      new Shubox(`#${this.uploadButton.current.id}`, {
        // key: process.env.SHUBOX_API,
        key: '47c62406-d183-46fe-b783-f6f3684d3352', // PROD
        // key: '368068b1-4cbb-4d84-a87c-6a273cb962df', // DEV
        // key: '21965b8a-1f6e-483d-a274-5b5fac618852',
        previewsContainer: false,
        acceptedFiles: 'image/gif,image/png,image/jpeg',
        transformName: "Auto-orient",
        // s3urlTemplate: 'image',
        success: (file) => {
          this.props.onChange({
            target: {
              name: this.props.name,
              value: this.shuboxFilePath(file),
            }
          })
        },
      })

      elem.dropzone.on("totaluploadprogress", (progress) => {
        this.setState({ progress: progress })
      })

      elem.dropzone.on("sending", (file) => {
        this.setState({ done: false })
      })

      elem.dropzone.on("queuecomplete", (progress) => {
        this.setState({ done: true })
      });

    }
  }

  componentDidUpdate() {
    this.shuboxify()
  }

  componentDidMount() {
    this.shuboxify()
  }

  removeImage() {
    this.props.onChange({
      target: {
        name: this.props.name,
        value: null,
      }
    })
  }

  render() {
    return <>
      {this.state.done ? (
        <React.Fragment>
          {this.props.value ? (
            <React.Fragment>
              <Image src={this.props.value} />
              <div>
                <ButtonUpload small style={{ marginRight: '10px' }}><div id="logo" ref={this.uploadButton}>Replace</div></ButtonUpload>
                <Button small onClick={this.removeImage}>Remove</Button>
              </div>
            </React.Fragment>
          ) : (
            <ButtonUpload small><div id="logo" ref={this.uploadButton}>Upload</div></ButtonUpload>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div>Uploading...</div>
          <Progress><Bar style={{width: this.state.progress + '%'}} /></Progress>
        </React.Fragment>
      )}
    </>
  }
}
export default Uploader